/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

type ItemsLayout = 'start' | 'end' | 'center' | 'stretch';

export type Props = {
  /**
   * How to vertically align the items within the grid layout.
   */
  alignItems?: ItemsLayout;
  /**
   * The content to render, which will become grid columns and rows.
   */
  children: React.ReactNode;
  /**
   * Number of columns or explicit column sizes.
   * Accepts any valid value for `grid-template-columns`.
   */
  columns?: number | string;
  /**
   * The space between rows and columns. Accepts any valid value for `gap`.
   * If you want to specify `row-gap` and `column-gap` independently,
   * use the CSS shorthand form of `gap`, which is `row-gap` followed by `column-gap`.
   */
  gap?: number | string;
};

const isNumber = (value: any) => typeof value === 'number';

const Styles = labelStyles('Grid', {
  root: (props: Props) =>
    css({
      display: 'grid',
      alignItems: props.alignItems,
      gap: props.gap,
      gridTemplateColumns: isNumber(props.columns)
        ? `repeat(${props.columns}, 1fr)`
        : props.columns,
    }),
});

export const Grid = (props: Props) => {
  return (
    <div css={Styles.root(props)} data-zds>
      {props.children}
    </div>
  );
};
